import { ApplicationUser } from '@/types/application-user';

export const isUserOrganisationAdmin = (
  user: Pick<ApplicationUser, 'role'>,
): boolean => user.role.id === 2;
